import styled from 'styled-components';

const Root = styled.div`
  user-select: none;
  cursor: pointer;
  flex-grow: 1;
  height: 2.75rem;
  padding: 0 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border-radius: 0.25rem;
  background-color: var(--board);
  .material-symbols-rounded {
    font-variation-settings: 'FILL' 1, 'wght' 600, 'GRAD' 0, 'opsz' 48;
    font-size: 1.5rem;
    color: var(--text-tertiary);
    &.checked {
      color: var(--primary) !important;
    }
  }
  .name {
    font-size: 0.875rem;
    color: var(--text-secondary);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .title {
    font-size: 0.75rem;
    color: var(--text-tertiary);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .meta {
    font-size: 0.75rem;
    color: var(--text-tertiary);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .text-wrap {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
    flex: 1;
    overflow: hidden;
    white-space: nowrap;
  }
  &:hover {
    background-color: var(--tonal-blue);
    box-shadow: inset 0 0 0 0.25rem var(--tonal-deep);
    z-index: 10;
    &:active {
      box-shadow: inset 0 0 0 0.25rem var(--primary);
    }
  }
`;

interface Props {
  data: JobtypeList;
  isSelected: boolean;
}

const ListBoxInModal = ({ data, isSelected }: Props) => {
  const icon = isSelected ? 'check_box' : 'check_box_outline_blank';
  const iconStyle = `material-symbols-rounded checkbox ${isSelected ? 'checked' : ''}`;
  const titleText = data.partName ? `${data.partName}` : '';
  const metaParts = [data.tel, data.bigo].filter((value) => value && String(value).trim() !== '');
  const metaText = metaParts.join(' / ');

  return (
    <Root>
      <span className={iconStyle}>{icon}</span>
      <div className='text-wrap'>
        <span className='name'>{data.name}</span>
        {titleText && <span className='title'>{titleText}</span>}
        {metaText && <span className='meta'>{metaText}</span>}
      </div>
    </Root>
  );
};

export default ListBoxInModal;
